module.exports = __webpack_public_path__ + "static/media/Ziggy Stardust & Magic Internet Money.03031053.png";